import React, { useState, useEffect, useImperativeHandle, forwardRef, Fragment, useRef } from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { makeStyles } from "@material-ui/core/styles";
import FilterButton from '../Common/FilterButton';
import FilterGroups from '../Common/FilterGroups';
import MedicalExamIcon from '../../../../icons/medical-exam.svg';
import AppTypeIcon from '../../../../icons/appType.svg';
import StructureIcon from '../../../../icons/structure.svg';
import ConvertibilityIcon from '../../../../icons/convertibility.svg';
import ConvertibilityConvertibleIcon from '../../../../icons/convertibility-convertible.svg';
import CloseIcon from '@material-ui/icons/Close';
import ShowAllIcon from '../../../../icons/show-all.svg';
import AppTypePhoneIcon from '../../../../icons/appType-Phone.svg';
import AppTypeDigitalIcon from '../../../../icons/appType-Digital.svg';
import MedicalExamNoIcon from '../../../../icons/medicalExam-no.svg';
import MedicalExamYesIcon from '../../../../icons/medicalExam-yes.svg';
import StructureLevelIcon from '../../../../icons/structure-level.svg';
import StructureDecreasingIcon from '../../../../icons/structure-decreasing.svg';
import ConvertibilityNotConvertibleIcon from '../../../../icons/convertibility-NotConvertible.svg';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
    lightBG: {
        backgroundColor: `${theme.palette.primary.main}16`,
        border: "none",
    },
    primaryColor: {
        color: theme.palette.primary.main
    },
    badgeBackgroundColor: {
        backgroundColor: theme.palette.primary.main,
    },
    uncheckedColor: {
        color: "#C6C6C6",
    },
    iconColor: {
        color: "#666",
    },
    borderOutline: {
        border: `1px solid ${theme.palette.primary.main}`
    },
    buttonClass: {
        border: 'none',
        backgroundColor: 'inherit',
        color: theme.palette.primary.main,
    },
    backButton: {
        color: "white",
        background: theme.palette.primary.main
    },
}));

const FilterItem = (props) => {
    const [value, setValue] = useState("");

    const handleChange = (e) => {
        setValue(e.target.value);
        props.onChange(value);
    };
    useEffect(() => {
        if (props.onChange) {
            props.onChange(value);
        }
    }, [value]);
    return (
        <FormControl component="fieldset">
            {props.fields.map((field, i) => {
                const label = (
                    <Fragment>
                        <span className="filter-icon">{field.icon}</span>Show All
                    </Fragment>
                );
               return <Fragment key={i}>
                        {field.isAllFilters && <FormLabel component="legend">{field.formLabel}</FormLabel>}
                        <RadioGroup aria-label={field.radio.label} name={field.radio.label} value={value} onChange={handleChange}>
                            <FormControlLabel value={field.default} control={<Radio color="primary" />} label={label} labelPlacement="start" checked={field.isDefault} />
                            {field.radio.map((r,i) => {
                                const label = (
                                    <Fragment>
                                        <span className="filter-icon">{r.icon}</span>{r.label}
                                    </Fragment>
                                );
                                return <FormControlLabel key={i} value={r.filterName} control={<Radio color="primary" />} label={label} labelPlacement="start" checked={r.selected} />;
                            })}
                        </RadioGroup>
                    </Fragment>;
                })}
        </FormControl>
    );
};

export default forwardRef((props, ref) => {
    const filterPopoverRef = useRef(null);
    const [isFilterShow, setIsFilterShow] = useState(false);
    const [filterCount, setFilterCount] = useState(0);
    const [filterState, setFilterState] = useState(props.filterObject || {
        noMedicalExamOnly: false,
        medicalExamOnly: false,
        digitalOnly: false,
        phoneOnly: false,
        convertibleOnly: false,
        notConvertibleOnly: false, 
        levelTerm: false,
        decreasingTerm: false,
    });
    
    const updateFilterState = (key) => {
        const obj = {...filterState};

        switch (key) {
            case "allApplicationType":
                obj["digitalOnly"] = false;
                obj["phoneOnly"] = false;
                break;
            case "digitalOnly":
                obj[key] = true;
                obj["phoneOnly"] = false;
                break;
            case "phoneOnly":
                obj[key] = true;
                obj["digitalOnly"] = false;
                break;
            case "allRequirements":
                obj["noMedicalExamOnly"] = false;
                obj["medicalExamOnly"] = false;
                break;
            case "noMedicalExamOnly":
                obj[key] = true;
                obj["medicalExamOnly"] = false;
                break;
            case "medicalExamOnly":
                obj[key] = true;
                obj["noMedicalExamOnly"] = false;
                break;
            case "allTermProductType":
                obj["levelTerm"] = false;
                obj["decreasingTerm"] = false;
                break;
            case "levelTerm":
                obj[key] = true;
                obj["decreasingTerm"] = false;
                break;
            case "decreasingTerm":
                obj[key] = true;
                obj["levelTerm"] = false;
                break;
            case "allConversionOptions":
                obj["convertibleOnly"] = false;
                obj["notConvertibleOnly"] = false;
                break;
            case "convertibleOnly":
                obj[key] = true;
                obj["notConvertibleOnly"] = false;
                break;
            case "notConvertibleOnly":
                obj[key] = true;
                obj["convertibleOnly"] = false;
                break;
        };

        setFilterState(obj);
    };

    useImperativeHandle(ref, () => ({
        updateFilterState
    }));

    const resetFilters = () => {
        const obj = { ...filterState };

        Object.keys(obj).forEach(key => {
            if (obj[key] === true) {
                obj[key] = false;
            }
        });

        setFilterState(obj);
    };

    const showFilter = () => {
        setIsFilterShow(!isFilterShow);
    };

    const handleFilterClose = (event) => {
        if (filterPopoverRef.current && !filterPopoverRef.current.contains(event.target)) {
            setIsFilterShow(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleFilterClose);
        return () => {
            document.removeEventListener("mousedown", handleFilterClose);
        };
    }, []);

    useEffect(() => {
        if (props.setFilterObject) {props.setFilterObject(filterState);}
        const count = Object.values(filterState).filter(f => f === true).length;
        setFilterCount(count);
    }, [filterState, filterCount]);

    const classes = useStyles();
    return (
        <React.Fragment>
            <div className="filter-control-wrapper">
                <div className={`filter-container ${props.isAmerico ? "filter-padding-tight" : ""}`}>
                    {!props.isAmerico && <Fragment>
                        <div className="filter-popover-container">
                            <button className={`filter-control ${classes.primaryColor}`} onClick={showFilter}>All Filters <div className={`filter-badge ${filterCount > 0 ? "count-mobile" : ""} ${classes.badgeBackgroundColor}`}><p>{filterCount}</p></div></button>
                            <div className={`filter-popover ${isFilterShow ? "filter-popover-visible" : ""}`} ref={filterPopoverRef}>
                                <div className="header">
                                    <h3>Filters</h3>
                                    <button onClick={showFilter}><CloseIcon /></button>
                                </div>
                                <div className="content">
                                    <FilterGroups label="Application Type" inputs={
                                        <FilterItem fields={[
                                            {
                                                formLabel: "Application Type",
                                                isAllFilters: true,
                                                default: "allApplicationType",
                                                isDefault: (!filterState.digitalOnly && !filterState.phoneOnly),
                                                icon:<ShowAllIcon className={(!filterState.digitalOnly && !filterState.phoneOnly) ? classes.primaryColor : classes.iconColor} />,
                                                radio:[
                                                    {
                                                        label:'Digital Application',
                                                        filterName: 'digitalOnly',
                                                        selected: filterState.digitalOnly,
                                                        icon:<AppTypeDigitalIcon className={filterState.digitalOnly ? classes.primaryColor : classes.iconColor} />,
                                                    },
                                                    {
                                                        label:'Phone Application',
                                                        filterName: 'phoneOnly',
                                                        selected: filterState.phoneOnly,
                                                        icon:<AppTypePhoneIcon className={filterState.phoneOnly ? classes.primaryColor : classes.iconColor} />,
                                                    }
                                                ]
                                            }]} onChange={updateFilterState} />} />
                                    <FilterGroups label="Requirements" inputs={
                                        <FilterItem fields={[
                                            {
                                                formLabel: "Requirements",
                                                isAllFilters: true,
                                                default: "allRequirements",
                                                isDefault: (!filterState.noMedicalExamOnly && !filterState.medicalExamOnly),
                                                icon:<ShowAllIcon className={(!filterState.noMedicalExamOnly && !filterState.medicalExamOnly) ? classes.primaryColor : classes.iconColor} />,
                                                radio:[
                                                    {
                                                        label:'No Medical Exam',
                                                        filterName: 'noMedicalExamOnly',
                                                        selected: filterState.noMedicalExamOnly,
                                                        icon:<MedicalExamNoIcon className={filterState.noMedicalExamOnly ? classes.primaryColor : classes.iconColor} />,
                                                    },
                                                    {
                                                        label:'Medical Exam',
                                                        filterName: 'medicalExamOnly',
                                                        selected: filterState.medicalExamOnly,
                                                        icon:<MedicalExamYesIcon className={filterState.medicalExamOnly ? classes.primaryColor : classes.iconColor} />,
                                                    }
                                                ]
                                            }]} onChange={updateFilterState} />} />
                                    <FilterGroups label="Term Product Type" inputs={
                                        <FilterItem fields={[
                                            {
                                                formLabel: "Term Product Type",
                                                isAllFilters: true,
                                                default: "allTermProductType",
                                                isDefault: (!filterState.levelTerm && !filterState.decreasingTerm),
                                                icon:<ShowAllIcon className={(!filterState.levelTerm && !filterState.decreasingTerm) ? classes.primaryColor : classes.iconColor} />,
                                                radio:[
                                                    {
                                                        label:'Level Term',
                                                        filterName: 'levelTerm',
                                                        selected: filterState.levelTerm,
                                                        icon:<StructureLevelIcon className={filterState.levelTerm ? classes.primaryColor : classes.iconColor} />,
                                                    },
                                                    {
                                                        label:'Decreasing Term',
                                                        filterName: 'decreasingTerm',
                                                        selected: filterState.decreasingTerm,
                                                        icon:<StructureDecreasingIcon className={filterState.decreasingTerm ? classes.primaryColor : classes.iconColor} />,
                                                    }
                                                ]
                                            }]} onChange={updateFilterState} />} />
                                    <FilterGroups label="Conversion Options" inputs={
                                        <FilterItem fields={[
                                            {
                                                formLabel: "Conversion Options",
                                                isAllFilters: true,
                                                default: "allConversionOptions",
                                                isDefault: (!filterState.convertibleOnly && !filterState.notConvertibleOnly),
                                                icon:<ShowAllIcon className={(!filterState.convertibleOnly && !filterState.notConvertibleOnly) ? classes.primaryColor : classes.iconColor} />,
                                                radio:[
                                                    {
                                                        label:'Convertible',
                                                        filterName: 'convertibleOnly',
                                                        selected: filterState.convertibleOnly,
                                                        icon:<ConvertibilityConvertibleIcon className={filterState.convertibleOnly ? classes.primaryColor : classes.iconColor} />,
                                                    },
                                                    {
                                                        label:'Not Convertible',
                                                        filterName: 'notConvertibleOnly',
                                                        selected: filterState.notConvertibleOnly,
                                                        icon:<ConvertibilityNotConvertibleIcon className={filterState.notConvertibleOnly ? classes.primaryColor : classes.iconColor} />,
                                                    }
                                                ]
                                            }]} onChange={updateFilterState} />} />
                                </div>
                                <div className="footer">
                                    <button className={`filter-control ${classes.primaryColor}`} onClick={resetFilters}>Reset Filters</button>
                                </div>
                            </div>
                        </div>

                        <div className="filter-button-group-container">
                            <div className="button-group">
                                <FilterButton label="Application Type" icon={<AppTypeIcon />} setDefaultFilter={updateFilterState} inputs={
                                    <FilterItem fields={[
                                        {
                                            formLabel: "Application Type",
                                            isAllFilters: false,
                                            default: "allApplicationType",
                                            isDefault: (!filterState.digitalOnly && !filterState.phoneOnly),
                                            icon:<ShowAllIcon className={(!filterState.digitalOnly && !filterState.phoneOnly) ? classes.primaryColor : classes.iconColor} />,
                                            radio:[
                                                {
                                                    label:'Digital Application',
                                                    filterName: 'digitalOnly',
                                                    selected: filterState.digitalOnly,
                                                    icon:<AppTypeDigitalIcon className={filterState.digitalOnly ? classes.primaryColor : classes.iconColor} />,
                                                },
                                                {
                                                    label:'Phone Application',
                                                    filterName: 'phoneOnly',
                                                    selected: filterState.phoneOnly,
                                                    icon:<AppTypePhoneIcon className={filterState.phoneOnly ? classes.primaryColor : classes.iconColor} />,
                                                }
                                            ]
                                        }]} onChange={updateFilterState} />} />
                                <FilterButton label="Requirements" icon={<MedicalExamIcon />} setDefaultFilter={updateFilterState} inputs={
                                    <FilterItem fields={[
                                        {
                                            formLabel: "Requirements",
                                            isAllFilters: false,
                                            default: "allRequirements",
                                            isDefault: (!filterState.noMedicalExamOnly && !filterState.medicalExamOnly),
                                            icon:<ShowAllIcon className={(!filterState.noMedicalExamOnly && !filterState.medicalExamOnly) ? classes.primaryColor : classes.iconColor} />,
                                            radio:[
                                                {
                                                    label:'No Medical Exam',
                                                    filterName: 'noMedicalExamOnly',
                                                    selected: filterState.noMedicalExamOnly,
                                                    icon:<MedicalExamNoIcon className={filterState.noMedicalExamOnly ? classes.primaryColor : classes.iconColor} />,
                                                },
                                                {
                                                    label:'Medical Exam',
                                                    filterName: 'medicalExamOnly',
                                                    selected: filterState.medicalExamOnly,
                                                    icon:<MedicalExamYesIcon className={filterState.medicalExamOnly ? classes.primaryColor : classes.iconColor} />,
                                                }
                                            ]
                                        }]} onChange={updateFilterState} />} />
                            </div>
                            <div className="button-group">
                                <FilterButton label="Term Product Type" icon={<StructureIcon />} setDefaultFilter={updateFilterState} inputs={
                                    <FilterItem fields={[
                                        {
                                            formLabel: "Term Product Type",
                                            isAllFilters: false,
                                            default: "allTermProductType",
                                            isDefault: (!filterState.levelTerm && !filterState.decreasingTerm),
                                            icon:<ShowAllIcon className={(!filterState.levelTerm && !filterState.decreasingTerm) ? classes.primaryColor : classes.iconColor} />,
                                            radio:[
                                                {
                                                    label:'Level Term',
                                                    filterName: 'levelTerm',
                                                    selected: filterState.levelTerm,
                                                    icon:<StructureLevelIcon className={filterState.levelTerm ? classes.primaryColor : classes.iconColor} />,
                                                },
                                                {
                                                    label:'Decreasing Term',
                                                    filterName: 'decreasingTerm',
                                                    selected: filterState.decreasingTerm,
                                                    icon:<StructureDecreasingIcon className={filterState.decreasingTerm ? classes.primaryColor : classes.iconColor} />,
                                                }
                                            ]
                                        }]} onChange={updateFilterState} />} />
                                <FilterButton label="Conversion Options" icon={<ConvertibilityIcon />} setDefaultFilter={updateFilterState} inputs={
                                    <FilterItem fields={[
                                        {
                                            formLabel: "Conversion Options",
                                            isAllFilters: false,
                                            default: "allConversionOptions",
                                            isDefault: (!filterState.convertibleOnly && !filterState.notConvertibleOnly),
                                            icon:<ShowAllIcon className={(!filterState.convertibleOnly && !filterState.notConvertibleOnly) ? classes.primaryColor : classes.iconColor} />,
                                            radio:[
                                                {
                                                    label:'Convertible',
                                                    filterName: 'convertibleOnly',
                                                    selected: filterState.convertibleOnly,
                                                    icon:<ConvertibilityConvertibleIcon className={filterState.convertibleOnly ? classes.primaryColor : classes.iconColor} />,
                                                },
                                                {
                                                    label:'Not Convertible',
                                                    filterName: 'notConvertibleOnly',
                                                    selected: filterState.notConvertibleOnly,
                                                    icon:<ConvertibilityNotConvertibleIcon className={filterState.notConvertibleOnly ? classes.primaryColor : classes.iconColor} />,
                                                }
                                            ]
                                        }]} onChange={updateFilterState} />} />
                            </div>
                        </div>

                        <button className={`filter-control ${classes.primaryColor}`} onClick={resetFilters}>Reset Filters</button>
                    </Fragment>}
                </div>
            </div>
        </React.Fragment>
    );
});

FilterItem.propTypes = {
    fields: PropTypes.object,
    onChange: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/Quoters/CustomizeTerm/QuoterComponents/QuoterFilters.js